/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AggregateKeyInfo } from './AggregateKeyInfo';
import {
    AggregateKeyInfoFromJSON,
    AggregateKeyInfoFromJSONTyped,
    AggregateKeyInfoToJSON,
} from './AggregateKeyInfo';
import type { BooleanSearch } from './BooleanSearch';
import {
    BooleanSearchFromJSON,
    BooleanSearchFromJSONTyped,
    BooleanSearchToJSON,
} from './BooleanSearch';
import type { TextSearch } from './TextSearch';
import {
    TextSearchFromJSON,
    TextSearchFromJSONTyped,
    TextSearchToJSON,
} from './TextSearch';

/**
 * 
 * @export
 * @interface AnneeReussieSearch
 */
export interface AnneeReussieSearch {
    /**
     * 
     * @type {TextSearch}
     * @memberof AnneeReussieSearch
     */
    libelle?: TextSearch;
    /**
     * 
     * @type {BooleanSearch}
     * @memberof AnneeReussieSearch
     */
    actif?: BooleanSearch;
    /**
     * 
     * @type {Array<string>}
     * @memberof AnneeReussieSearch
     */
    sortKey?: Array<string> | null;
    /**
     * 
     * @type {Array<AggregateKeyInfo>}
     * @memberof AnneeReussieSearch
     */
    aggregateKeys?: Array<AggregateKeyInfo> | null;
    /**
     * 
     * @type {number}
     * @memberof AnneeReussieSearch
     */
    forceSkip?: number | null;
    /**
     * 
     * @type {number}
     * @memberof AnneeReussieSearch
     */
    forceTake?: number | null;
    /**
     * 
     * @type {any}
     * @memberof AnneeReussieSearch
     */
    parameters?: any | null;
    /**
     * 
     * @type {string}
     * @memberof AnneeReussieSearch
     */
    filter?: string | null;
}

/**
 * Check if a given object implements the AnneeReussieSearch interface.
 */
export function instanceOfAnneeReussieSearch(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function AnneeReussieSearchFromJSON(json: any): AnneeReussieSearch {
    return AnneeReussieSearchFromJSONTyped(json, false);
}

export function AnneeReussieSearchFromJSONTyped(json: any, ignoreDiscriminator: boolean): AnneeReussieSearch {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'libelle': !exists(json, 'libelle') ? undefined : TextSearchFromJSON(json['libelle']),
        'actif': !exists(json, 'actif') ? undefined : BooleanSearchFromJSON(json['actif']),
        'sortKey': !exists(json, 'sortKey') ? undefined : json['sortKey'],
        'aggregateKeys': !exists(json, 'aggregateKeys') ? undefined : (json['aggregateKeys'] === null ? null : (json['aggregateKeys'] as Array<any>).map(AggregateKeyInfoFromJSON)),
        'forceSkip': !exists(json, 'forceSkip') ? undefined : json['forceSkip'],
        'forceTake': !exists(json, 'forceTake') ? undefined : json['forceTake'],
        'parameters': !exists(json, 'parameters') ? undefined : json['parameters'],
        'filter': !exists(json, 'filter') ? undefined : json['filter'],
    };
}

export function AnneeReussieSearchToJSON(value?: AnneeReussieSearch | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'libelle': TextSearchToJSON(value.libelle),
        'actif': BooleanSearchToJSON(value.actif),
        'sortKey': value.sortKey,
        'aggregateKeys': value.aggregateKeys === undefined ? undefined : (value.aggregateKeys === null ? null : (value.aggregateKeys as Array<any>).map(AggregateKeyInfoToJSON)),
        'forceSkip': value.forceSkip,
        'forceTake': value.forceTake,
        'parameters': value.parameters,
        'filter': value.filter,
    };
}

